import Reveal from "./Reveal";
import { useLang } from "../i18n";

const Manifesto = () => {
  const { t } = useLang();
  const chapters = [
    {
      n: "01",
      title: t("mani.c1t", "The Thesis"),
      body: t(
        "mani.c1b",
        "Aging is not a law of nature; it is an unsolved engineering problem. We are firm believers that human beings can achieve immortality theoretically, and a lifespan beyond 150 years practically, within the near future. Every discipline we touch points in the same direction."
      ),
    },
    {
      n: "02",
      title: t("mani.c2t", "The Method"),
      body: t(
        "mani.c2b",
        "Our research and computing programs run at subliminal scale; below the noise, across the full stack of matter and mind. From particle interactions to neural computation, we model life as a system that can be understood, simulated, and extended."
      ),
    },
    {
      n: "03",
      title: t("mani.c3t", "The Horizon"),
      body: t(
        "mani.c3b",
        "This is not a century-long moonshot. Within the next two years we roll out our first solutions; the opening artifacts of a much larger program. What follows compounds."
      ),
    },
    {
      n: "04",
      title: t("mani.c4t", "The Model"),
      body: t(
        "mani.c4b",
        "Our research is sustained by a broad ecosystem: backers, investors, academic subscribers, philanthropists, HNIs, entrepreneurs, assisting companies and corporate sponsors. Products and services flow through The Lifespan Labs to keep that research moving; they are the engine, never the purpose."
      ),
    },
  ];

  return (
    <section id="thesis" data-testid="manifesto-section" className="relative py-28 md:py-40">
      <div className="mx-auto max-w-6xl px-6">
        <Reveal testId="manifesto-heading" className="text-center">
          <p className="text-gradient mb-6 font-mono text-base uppercase tracking-[0.3em]">
            {t("mani.eyebrow", "The Manifesto")}
          </p>
          <h2 className="mx-auto max-w-3xl font-display text-[2rem] font-semibold leading-[1.08] tracking-tight sm:text-[2.75rem]">
            {t("mani.h2a", "Death is the oldest")} <span className="text-gradient">{t("mani.h2b", "unsolved problem")}</span>{" "}
            {t("mani.h2c", "in physics.")}
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-6 md:grid-cols-2">
          {chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.08} testId={`manifesto-chapter-${c.n}`}>
              <article className="group h-full rounded-3xl border border-white/10 bg-surface p-10 transition-colors duration-500 hover:border-white/25 md:p-12">
                <span className="text-gradient font-mono text-base tracking-[0.2em]">
                  [{c.n}]
                </span>
                <h3 className="mt-6 font-display text-2xl font-semibold tracking-tight md:text-3xl">
                  {c.title}
                </h3>
                <p className="mt-4 text-base font-light leading-relaxed text-fog">
                  {c.body}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
